module.exports = __webpack_public_path__ + "static/media/right_drive.7cf1a197.png";